import React, { useEffect, useState } from "react";
import { grouplist } from "../../../services/admin";
import { AgGridReact } from "ag-grid-react";
import { useNavigate } from "react-router-dom";

export default function Allloan() {
    const navigate= useNavigate();
    const [filterProduct, setFilterProduct] = useState([]);
    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 150,
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
              return (
                <div className="text-center">
                  <a className="btn-sm btn-info me-2" onClick={() => navigate(`/loan/memberlist/${params.value}`)}>
                    <i className="fa fa-edit"></i> Select Group
                  </a>
                
                </div>
              );
            },
          },
        {
            headerName: "Group ID",
            field: "group_id",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Group Name",
            field: "group_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Total Members",
            field: "member_count",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Due On",
            field: "group_due",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Collection Day",
            field: "group_collection_day",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Staff",
            field: "staff_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Branch",
            field: "branch_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Center",
            field: "group_center",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
    ];

    useEffect(() => {
        funlist();
    }, []);

    function funlist() {
        setFilterProduct([]);
        const temp=new FormData();
        temp.append("branch", localStorage.getItem("branch"));
        grouplist(temp).then((res) => {
            if (res.status === true) {
                setFilterProduct(res.data);
            }
        });
    }


    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">All Loan</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Loan</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        All Loan
                    </li>
                </ol>
            </div>

           
                <div className="content-body">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-header">
                                    <h2 className="main-content-title tx-24 mg-b-5">
                                        All Loan List
                                    </h2>
                                </div>
                                <div className="card-body">
                                    <div className="ag-theme-alpine ag-style mt-2">
                                        <AgGridReact
                                            columnDefs={columnDefs}
                                            rowData={filterProduct}
                                            pagination="true"
                                            paginationPageSize="10"
                                            sortingOrder={["asc", "desc"]}
                                            suppressDragLeaveHidesColumns={true}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    );
}
